export const EMPTY_SELECT_OPTION = { id: -9999, key: -9999, name: 'Selecione', title: 'Selecione', description: 'Selecione' };
export const DROPDOWN_MENU_TYPE_ITEM = 1;
export const DROPDOWN_MENU_TYPE_HEADER = 2;
export const DROPDOWN_MENU_TYPE_DIVIDER = 3;

export const questionTypes = [
    { id: 1, name: 'Multipla escolha', machineName: 'multipleOptions' },
    { id: 2, name: 'Dissertativa', machineName: 'discursive' },
];

//Tipos de item de quadro de horários
export const TIMESHEET_ITEM_ENTITY_TYPE_DISCIPLINE = 1;
export const TIMESHEET_ITEM_ENTITY_TYPE_ACTIVITY = 2;
export const TIMESHEET_ITEM_ENTITY_TYPE_NOT_INFORMED = -9999;


export const timesheetItemEntityTypes = [
    { id: TIMESHEET_ITEM_ENTITY_TYPE_DISCIPLINE, name: 'Disciplina', machineName: 'Discipline' },
    { id: TIMESHEET_ITEM_ENTITY_TYPE_ACTIVITY, name: 'Atividade Extra', machineName: 'TimesheetActivity' },
    { id: TIMESHEET_ITEM_ENTITY_TYPE_NOT_INFORMED, name: 'Não informado', machineName: 'NotInformed' },


];

//Tipos de presença
export const ATTENDANCE_TYPE_PRESENT = 1;
export const ATTENDANCE_TYPE_DELAY = 2;
export const ATTENDANCE_TYPE_ABSENCE = 3;
export const ATTENDANCE_TYPE_AUTHORISED_ABSENCE = 4;
export const ATTENDANCE_TYPE_NOT_INFORMED = -9999;


export const attendanceTypes = [
    { id: ATTENDANCE_TYPE_PRESENT, name: 'Presença', machineName: 'Presence' },
    { id: ATTENDANCE_TYPE_DELAY, name: 'Atraso', machineName: 'Delay' },
    { id: ATTENDANCE_TYPE_ABSENCE, name: 'Falta', machineName: 'Absence' },
    { id: ATTENDANCE_TYPE_AUTHORISED_ABSENCE, name: 'Falta Justificada', machineName: 'AuthorisedAbsence' },
    { id: ATTENDANCE_TYPE_NOT_INFORMED, name: 'Não informado', machineName: 'NotInformed' },

];

//Tipos de entidade
export const ENTITY_TYPE_PERSON = 1;
export const ENTITY_TYPE_STUDENT = 2;
export const ENTITY_TYPE_RESPONSIBLE = 3;
export const ENTITY_TYPE_EMPLOYEE = 4;


export const entityTypes = [
    { id: ENTITY_TYPE_PERSON, name: 'Prospect', machineName: 'prospect' },
    { id: ENTITY_TYPE_STUDENT, name: 'Aluno', machineName: 'student' },
    { id: ENTITY_TYPE_RESPONSIBLE, name: 'Responsável', machineName: 'responsible' },
    { id: ENTITY_TYPE_EMPLOYEE, name: 'Colaborador', machineName: 'employee' },

];

//Tipos de media
export const MEDIA_FILE_TYPE_FILE = 1;
export const MEDIA_FILE_TYPE_LINK = 2;
export const MEDIA_FILE_TYPE_YOUTUBE = 3;


export const mediaTypes = [
    { id: MEDIA_FILE_TYPE_FILE, name: 'Arquivo', machineName: 'File' },
    { id: MEDIA_FILE_TYPE_LINK, name: 'Link', machineName: 'Link' },
    { id: MEDIA_FILE_TYPE_YOUTUBE, name: 'Youtube', machineName: 'Youtube' },
];

//Tipos de formula dos períodos
export const PERIOD_FORMULA_TYPE_DEFAULT = 1;
export const PERIOD_FORMULA_TYPE_CUSTOM = 2;


export const periodFormulaTypes = [
    { id: PERIOD_FORMULA_TYPE_DEFAULT, name: 'Avaliações cadastradas em `Tipos de avaliação`', machineName: 'default' },
    { id: PERIOD_FORMULA_TYPE_CUSTOM, name: 'O resultado de outros períodos', machineName: 'custom' },
];

//Tipos de formulas dos critérios de aprovação
export const STAGE_CRITERIA_FORMULA_TYPE_DEFAULT = 1;
export const STAGE_CRITERIA_FORMULA_TYPE_CUSTOM = 2;


export const stageCriteriaFormulaTypes = [
    { id: STAGE_CRITERIA_FORMULA_TYPE_DEFAULT, name: 'A fórmula definida na aba `formula das etapas`', machineName: 'default' },
    { id: STAGE_CRITERIA_FORMULA_TYPE_CUSTOM, name: 'Uma fórmula customizada', machineName: 'custom' },
];

//Tipos de formula das períodos
export const STAGE_FORMULA_TYPE_DEFAULT = 1;
export const STAGE_FORMULA_TYPE_CUSTOM = 2;


export const stageFormulaTypes = [
    { id: STAGE_FORMULA_TYPE_DEFAULT, name: 'média padrão (soma dos resultados dividida pela quantidade de períodos)', machineName: 'default' },
    { id: STAGE_FORMULA_TYPE_CUSTOM, name: 'fórmula customizada', machineName: 'custom' },
];


//Tipos de frequencia no regime de avaliação
export const EVALUATION_SCHEME_FREQUENCY_TYPE_STUDENT = 0;
export const EVALUATION_SCHEME_FREQUENCY_TYPE_DISCIPLINE = 1;


export const evaluationSchemeFrequencyTypes = [
    { id: EVALUATION_SCHEME_FREQUENCY_TYPE_STUDENT, name: 'por dia', machineName: 'daily_frequency' },
    { id: EVALUATION_SCHEME_FREQUENCY_TYPE_DISCIPLINE, name: 'por aula (disciplina)', machineName: 'discipline_frequency' },
];

//Regime de avaliação com ou sem dependencia
export const EVALUATION_SCHEME_DEPENDENCY_TYPE_WITHOUT = 0;
export const EVALUATION_SCHEME_DEPENDENCY_TYPE_WITH = 1;


export const evaluationSchemeDependencyTypes = [
    { id: EVALUATION_SCHEME_DEPENDENCY_TYPE_WITHOUT, name: 'sem dependência', machineName: 'without_dependency' },
    { id: EVALUATION_SCHEME_DEPENDENCY_TYPE_WITH, name: 'com dependência', machineName: 'with_dependency' },
];

//Métodos de sobrescrita de período períodos
export const PERIOD_REPLACE_TYPE_EVALUATION_TYPE = 1;
export const PERIOD_REPLACE_TYPE_RESULT = 2;
export const PERIOD_REPLACE_TYPE_SPECIFIC_EVALUATION_TYPE = 3;

//Evaluation Formula token types
export const EVALUATION_FORMULA_TOKEN_TYPE_PLACEHOLDER = 1;
export const EVALUATION_FORMULA_TOKEN_TYPE_OPERATOR = 2;
export const EVALUATION_FORMULA_TOKEN_TYPE_NUMERIC_VALUE = 3;

//Tipos sanguíneos
export const bloodTypes = [
    { id: 1, name: 'A-', machineName: 'a_negative' },
    { id: 2, name: 'B-', machineName: 'b_negative' },
    { id: 3, name: 'AB-', machineName: 'ab_negative' },
    { id: 4, name: 'O-', machineName: 'o_negative' },
    { id: 5, name: 'A+', machineName: 'a_positive' },
    { id: 6, name: 'B+', machineName: 'b_positive' },
    { id: 7, name: 'AB+', machineName: 'ab_positive' },
    { id: 8, name: 'O+', machineName: 'o_positive' }
];

//Estado civil
export const maritalStatuses = [
    { id: 1, name: 'Solteiro(a)', machineName: 'single' },
    { id: 2, name: 'Casado(a)', machineName: 'married' },
    { id: 3, name: 'Separado(a)', machineName: 'separated' },
    { id: 4, name: 'Divorciado(a)', machineName: 'divorced' },
    { id: 5, name: 'Viúvo(a)', machineName: 'widowed' }
];

//Tipos de telefone
export const phoneTypes = [
    { id: 1, name: 'Celular', machineName: 'mobile' },
    { id: 2, name: 'Residencial', machineName: 'residential' },
    { id: 3, name: 'Trabalho', machineName: 'work' },
    { id: 4, name: 'Whastapp', machineName: 'whatsapp' },
];

//Genero

export const genders = [
    { id: 1, name: 'Masculino', machineName: 'male' },
    { id: 2, name: 'Feminino', machineName: 'female' },
    { id: 3, name: 'Outros', machineName: 'other' }
];

//Tipo de documento
export const documentFieldTypes = [
    { id: 1, name: 'CPF', machineName: 'cpf' },
    { id: 2, name: 'CNPJ', machineName: 'cnpj' }
];


export const entitiesLabel = {
    student: "Aluno",
    employee: "Colaborador"
};


//Status do aluno na turma
export const CLASSROOM_STUDENT_STATUS_ACTIVE = 1;
export const CLASSROOM_STUDENT_STATUS_LOCKED = 2;
export const CLASSROOM_STUDENT_STATUS_REMOVED = 3;
export const CLASSROOM_STUDENT_STATUS_TRANSFERED = 4;
export const CLASSROOM_STUDENT_STATUS_COMPLETED = 5;

//Permission Types de diretórios (turma)
export const MEDIA_DIRECTORY_MACRO_ALLOW = 1;
export const MEDIA_DIRECTORY_MACRO_DENY = 2;
export const MEDIA_DIRECTORY_MACRO_CUSTOM = 3;

export const mediaDirectoryPermissions = [
    { id: MEDIA_DIRECTORY_MACRO_ALLOW, name: 'Permitir todos', machineName: 'Allow' },
    { id: MEDIA_DIRECTORY_MACRO_DENY, name: 'Negar todos', machineName: 'Deny' },
    { id: MEDIA_DIRECTORY_MACRO_CUSTOM, name: 'Customizar', machineName: 'Custom' }
];

//Permission Types de diretórios (aluno)
export const MEDIA_DIRECTORY_STUDENT_ALLOW = 1;
export const MEDIA_DIRECTORY_STUDENT_DENY = 2;

export const mediaDirectoryCustomPermissions = [
    { id: MEDIA_DIRECTORY_STUDENT_ALLOW, name: 'Permitir todos', machineName: 'Allow' },
    { id: MEDIA_DIRECTORY_STUDENT_DENY, name: 'Negar todos', machineName: 'Deny' }
];

//Opções padrão
export const PERSON_LOOKUP_OPTION_NONE = "Não encontrei quem eu queria...";

//Modo de exportação de atividades
export const ACTIVITY_EXPORT_ANSWERS_SHEET_AT_END = 1;
export const ACTIVITY_EXPORT_ANSWERS_AFTER_QUESTION = 2;
export const ACTIVITY_EXPORT_QUESTIONS_ONLY = 3;
export const ACTIVITY_EXPORT_ANSWERS_SHEET_ONLY = 4;

export const activityExportModes = [
    { id: ACTIVITY_EXPORT_ANSWERS_SHEET_AT_END, machineName: 'answer_sheet_at_end', name: 'Gabarito no final do arquivo' },
    { id: ACTIVITY_EXPORT_ANSWERS_AFTER_QUESTION, machineName: 'answer_sheet_after_question', name: 'Gabarito após cada questão' },
    { id: ACTIVITY_EXPORT_QUESTIONS_ONLY, machineName: 'questions_only', name: 'Somente as questões' },
    { id: ACTIVITY_EXPORT_ANSWERS_SHEET_ONLY, machineName: 'answer_sheet_only', name: 'Somente o gabarito' }
];

//Tipos de items de um item de fórmula de avaliação (TermInfo)
export const TERM_INFO_ITEM_TYPE_EVALUATION_TYPE = 1;
export const TERM_INFO_ITEM_TYPE_EVALUATION_PERIOD = 2;
export const TERM_INFO_ITEM_TYPE_EVALUATION_STAGE = 3;
export const TERM_INFO_ITEM_TYPE_DISCIPLINE = 4;


export const termInfoItemTypes = [
    { id: TERM_INFO_ITEM_TYPE_EVALUATION_TYPE, name: 'Tipo de avaliação', machineName: 'evaluation_type' },
    { id: TERM_INFO_ITEM_TYPE_EVALUATION_PERIOD, name: 'Período', machineName: 'evaluation_period' },
    { id: TERM_INFO_ITEM_TYPE_EVALUATION_STAGE, name: 'Etapa', machineName: 'evaluation_stage' },
    { id: TERM_INFO_ITEM_TYPE_DISCIPLINE, name: 'Disciplina', machineName: 'discipline' },

];

// Evaluations Autosave statuses
export const EVALUATION_AUTOSAVE_STATUS_IDLE = "idle";
export const EVALUATION_AUTOSAVE_STATUS_PENDING = "pending";
export const EVALUATION_AUTOSAVE_STATUS_SAVING = "saving";
export const EVALUATION_AUTOSAVE_STATUS_SAVED = "saved";
export const EVALUATION_AUTOSAVE_STATUS_ERROR = "error";

//Tipos de relatório
export const reportTypes = {
    ClassroomAttendance: "ClassroomAttendance",
    DisciplineAttendance: "ActivityResults",
    ActivityResults: "ActivityResults",
    StudentGrades: "StudentGrades",
};


export const constants = {
    questionTypes: questionTypes,
    genders: genders,
    bloodTypes: bloodTypes,
    maritalStatuses: maritalStatuses,
    phoneTypes: phoneTypes,
    documentFieldTypes: documentFieldTypes,
    entitiesLabel: entitiesLabel,
    entityTypes: entityTypes,
    mediaDirectoryPermissions: mediaDirectoryPermissions,
    mediaDirectoryCustomPermissions: mediaDirectoryCustomPermissions,
    activityExportModes: activityExportModes,
    timesheetItemEntityTypes: timesheetItemEntityTypes,
    periodFormulaTypes: periodFormulaTypes,
    stageCriteriaFormulaTypes: stageCriteriaFormulaTypes,
    evaluationSchemeFrequencyTypes: evaluationSchemeFrequencyTypes,
    evaluationSchemeDependencyTypes: evaluationSchemeDependencyTypes,
    termInfoItemTypes: termInfoItemTypes,
    reportTypes: reportTypes
}

export default constants;